import script from "./Icp.vue?vue&type=script&lang=ts&setup=true"
export * from "./Icp.vue?vue&type=script&lang=ts&setup=true"

import "./Icp.vue?vue&type=style&index=0&id=0efd8488&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17+webpack@5.100.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0efd8488"]])

export default __exports__